import React, { useState, useCallback, memo } from "react";
import clsx from "clsx";
import { ScrollToBottomButton, TextArea } from "components/common";
import { TfiWorld } from "react-icons/tfi";
import { PiFan } from "react-icons/pi";
import { RiUploadCloud2Line } from "react-icons/ri";
import Devider from "components/common/Devider/Devider";
import classes from "./ChatScreen.module.css";
import { BiUpArrowAlt } from "react-icons/bi";
import { useAppContext } from "ContextProvider/ContextProvider";
import { deleteChatsByChatId } from "db";
import { NavLink, useNavigate } from "react-router-dom";
import AiCharecters from "components/Home/AiCharecters/AiCharecters";

const ChatInput = memo(({
  selectedModel,
  input,
  aiCharacter,
  setInput,
  sendMessage,
  uploadedFile,
  setUploadedFile,
  isWebEnabled,
  setIsWebEnabled,
  showSelectAiDropdown,
  setShowSelectAiDropdown,
  chatId,
  generating,
  onCancel,
}) => {
  const { leftSidebar, allowEnterToSubmit, rightSidebar } = useAppContext();
  const [localDrop, setLocalDrop] = useState(false);
  const navigate = useNavigate();
  
  const handleFileUpload = useCallback((event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFile(file);
    }
  }, [setUploadedFile]);

  const handleSendMessage = useCallback(() => {
    if (!generating) {
      sendMessage();
    }
  }, [generating, sendMessage]);

  const handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  return (
    <div
      className={clsx(
        classes.inputContainer,
        !leftSidebar && classes.noLeftSidebarWrapper,
        !rightSidebar && classes.noRightSidebarWrapper
      )}
    >
      <div className={clsx(classes.inputWrapper, "container2")}>
        <div className={classes.inputRow}>
          <TextArea
            textarea
            type="text"
            value={input}
            setValue={setInput}
            placeholder="Ask anything..."
            className={classes.input}
            rows={1}
            onKeyDown={(e) => {
              if (allowEnterToSubmit && e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
          />
          {!generating && (
            <button
              type="button"
              onClick={handleSendMessage}
              className={clsx(classes.sendButton)}
            >
              <BiUpArrowAlt />
            </button>
          )}
          {generating && (
            <button
              onClick={handleCancel}
              className={clsx(classes.sendButton, classes.cancelButotn)}
            >
              <div className={classes.circle} />
            </button>
          )}
        </div>
        <div className={classes.sendContainer}>
          <Devider className={classes.devider} />
          <div className={classes.buttonContainer}>
            <input
              type="file"
              id="fileInput"
              className={classes.fileInput}
              onChange={handleFileUpload}
            />
          </div>
        </div>
        <ScrollToBottomButton className={classes.scrollToBottomButton} />
      </div>
    </div>
  );
});

export default ChatInput;
